import { IconButton, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import useMeasure from 'react-use-measure'
import useCaptcha from "../../../api/captchap";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { MuniSpinner2 } from "../../../components";
import './style.css'




const Captcha = ({ datosSobre, valor, setDatosSobre, setValor, correoElectronico, setCorreoElectronico, setVerify ,setErrores, errores}) => {

    const imagenes = [
        {
            img: "https://webservice.muninqn.gov.ar/cglobales/assets/captcha-imagenes/1.svg",
            value: 1
        },
        {
            img: "https://webservice.muninqn.gov.ar/cglobales/assets/captcha-imagenes/2.svg",
            value: 2
        },
        {
            img: "https://webservice.muninqn.gov.ar/cglobales/assets/captcha-imagenes/3.svg",
            value: 3
        },
        {
            img: "https://webservice.muninqn.gov.ar/cglobales/assets/captcha-imagenes/4.svg",
            value: 4
        },
        {
            img: "https://webservice.muninqn.gov.ar/cglobales/assets/captcha-imagenes/5.svg",
            value: 5
        },
        {
            img: "https://webservice.muninqn.gov.ar/cglobales/assets/captcha-imagenes/6.svg",
            value: 6
        },
        {
            img: "https://webservice.muninqn.gov.ar/cglobales/assets/captcha-imagenes/7.svg",
            value: 7
        },
        {
            img: "https://webservice.muninqn.gov.ar/cglobales/assets/captcha-imagenes/8.svg",
            value: 8
        },
        {
            img: "https://webservice.muninqn.gov.ar/cglobales/assets/captcha-imagenes/9.svg",
            value: 9
        },
    ]

    const [pregunta, setPregunta] = useState();
    const [preguntas, setPreguntas] = useState([]);
    const [imagenesRandom, setImagenesRandom] = useState();
    const [imgSelect, setImgSelect] = useState();
    const { getPregunta, verificarCaptcha } = useCaptcha();
    const [animacionPregunta, setAnimacionPregunta] = useState(false);
    const { loads } = useGeneralAppStore();

    const orderRandom = () => {
        setImagenesRandom(imagenes.sort(() => Math.random() - 0.5));
    }

    useEffect(() => {
        getPregunta(setPregunta, orderRandom, setPreguntas, null, setAnimacionPregunta);

    }, [])


    useEffect(() => {
        orderRandom();
    }, [pregunta])


    return (
        <>
            <section className=" mx-auto d-flex flex-column gap-1 bg-white position-relative" style={{ width: "100%" }}>
                {
                    (loads.includes('pregunta') || loads.includes('verificar')) && <div className="w-100 h-100 position-absolute d-flex justify-content-center align-items-center" style={{ left: 0, top: "0", backgroundColor: "rgba(255,255,255,0.96)" }}>
                        <MuniSpinner2 />
                    </div>
                }
                <div className="position-relative bg-primary-subtle d-flex p-3" style={{minHeight:"80px"}}>
                    {
                        pregunta &&
                        <div>
                            <p className={`text-primary m-0 ${animacionPregunta && "pregunta"} `}>Marcar la señal de</p>
                            <h5 className={` m-0  ${animacionPregunta && "pregunta"} `}>
                                {pregunta}
                            </h5>
                        </div>
                    }
                </div>
                <div className="row  m-0  mx-auto ">
                    {
                        imagenesRandom?.map((img, index) => (
                            <div key={index} className="col-4 "
                                style={{ padding: "4px" }}
                            >
                                <div
                                    style={{
                                        backgroundColor: "#fff",
                                        minHeight: "80px", border: imgSelect?.value == img.value ? "3px solid blue" : "3px solid white"
                                    }}
                                    onClick={() => { setImgSelect(img) }}
                                >
                                    <img src={img.img} alt="img-captcha" style={{ objectFit: "contain", width: "100%" }} />

                                </div>
                            </div>
                        ))
                    }
                </div>
                {/* <p className="alert alert-info mb-0">Intento {errores+1} de 3</p> */}
                <hr />
                <div className="d-flex justify-content-between">
                    <IconButton
                        disabled={loads.includes('verificar') || loads.includes('pregunta')  }
                        onClick={() => {
                            getPregunta(setPregunta, orderRandom, setPreguntas, setImgSelect, setAnimacionPregunta);
                            // preguntaRandom()
                            // orderRandom()
                        }}
                    >
                        <Tooltip arrow title="Resetear" >
                            <RestartAltIcon />
                        </Tooltip>
                    </IconButton>

                    <Button
                    disabled={!imgSelect}
                    size="sm" onClick={() => { verificarCaptcha({ pregunta: pregunta, respuesta: imgSelect.img, preguntas: preguntas }, setPreguntas, setPregunta, datosSobre, valor, setDatosSobre, setValor, correoElectronico, setCorreoElectronico, setAnimacionPregunta, setVerify,setErrores, errores) }}>Verificar</Button>
                </div>

            </section >
        </>
    );
}
export default Captcha;